
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";

// import Select from 'react-select';

const FeeWaiverAllocation = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [ddlWaivers, setDdlWaivers] = useState([]);
  const [ddlSection, setDdlSection] = useState([]);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState({});

  // Header State
  const [headerData, setHeaderData] = useState({
    fw_id: '',
    year1: '',
    year2: '',
  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      section_id: '',
      gr_no: '',
      stud_name: '',
      std_id: '',
      div_id: '',
      std_div: '',
      existing_fw: '',
      remarks: '',
    }
  ]);

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({ ...prev, [name]: value }));

    if (name === 'year1') {
       setHeaderData(prev => ({ ...prev, year2: Number(value) + 1 }));
    }

    setErrors(prev => ({ ...prev, [name]: "" }));

  };

  const handleChildChange = async (index, e) => {

    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);

    if (name === 'section_id') {
      setChildRows(prev =>
      prev.map((row, i) =>
        i === index
          ? {...row,
            gr_no: '',
            stud_name: null,
            std_div: null,
            existing_fw: null,
            remarks: null,
          }
          : row
      )
    );
    }

    setErrors({});

  };

  const handleGRNoBlur = async (index, e) => {

    const { name, value } = e.target;
    const updatedRows = [...childRows];

    setChildRows(prev =>
      prev.map((row, i) =>
        i === index
          ? {...row,
            stud_name: null,
            std_div: null,
            existing_fw: null,
            remarks: null,
          }
          : row
      )
    );
    
    if (value && Number(value) > 0) {
       const response = await axios.get(`${BASE_URL}/api/get_stud_name_fw`,
        { params: { p_Year1: headerData.year1, p_Section_Id: updatedRows[index].section_id, p_GR_No: value } }
       );
      if (response.data.length > 0) {
        const data = response.data[0];
        setChildRows(prev =>
          prev.map((row, i) =>
            i === index ? {
                ...row,
                stud_name: data.stud_name,
                std_div: data.std_div,
                std_id: data.std_id,
                div_id: data.div_id,
                existing_fw: data.fw_desc,
              } : row
          ) );
      } else {
        toast.error('Invalid GR No.');
      }
      
    }

  };

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const WaiversResult = await axios.get(`${BASE_URL}/api/ddl_fees_waivers`);
        setDdlWaivers(WaiversResult.data);

        const sectionresult = await axios.get(`${BASE_URL}/api/ddl_sections`);
        setDdlSection(sectionresult.data);

        const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
        setDdlAcademicYears(year_result.data);


      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const addRow = () => {

    setChildRows([...childRows, { section_id: '', gr_no: '', stud_name: '', std_div: '', existing_fw: '', std_id: '', div_id: '' }]);

  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {

    resetPage();
    setIsEditable(true);

  };

  const handleSave = async () => {

    const newErrors = {};

    if (!headerData.fw_id ) {
      newErrors.fw_id = 'Error';
      toast.error('Please enter Fee Waiver Description');
    }
    else if (!headerData.year1 || headerData.year1 === '') {
      newErrors.year1 = 'Error';
      toast.error('Please select Academic Year.');
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    const errors = {};

    for (let i = 0; i < childRows.length; i++) {

      const row = childRows[i];

      // Section/GR No Validation
      if (!row.stud_name || row.fee_code === '') {
        errors[i] = { field: 'gr_no' };
        setRowErrors(errors);
        document.getElementById(`gr_no_${i}`)?.focus();
        toast.error(`Please select GR No at Row # ${i + 1}`);
        return;
      }

    }

    // =========================
    // Duplicate Validation
    // =========================

    const rowSet = new Set();
    let key;

    for (let i = 0; i < childRows.length; i++) {

      key = `${childRows[i].section_id}_${childRows[i].gr_no}`;

      if (rowSet.has(key)) {
        errors[i] = { field: 'gr_no' };
        setRowErrors(errors);
        document.getElementById(`gr_no_${i}`)?.focus();
        toast.error(`Duplicate GR No. selected at Row # ${i + 1}`);
        return;
      }
      rowSet.add(key);
    }

    // clear errors if validation passed
    setRowErrors({});

    const isConfirmed = window.confirm("Save the record ?");

    if (!isConfirmed) return;

    const allocationdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_fw_allocation`, allocationdata);

    if (response.data.message === '1') {
      toast.success('Fee Waiver Allocation saved successfully.');
      resetPage();
    } else {
      toast.error('Unable to Allocate Fee Waiver.');
    }

  };

  const resetPage = () => {

    setIsEditable(false);
    setHeaderData({ fw_id: '', year1: '', year2: '', });

    setChildRows([{ section_id: '', gr_no: '', stud_name: '', std_div: '', existing_fw: '', std_id: '', div_id: ''}]);

  }

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
    }
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {<Row className="mb-3">

          <Col md={8}>
            <InputGroup>
              <InputGroup.Text style={{ width: "190px" }}>
                Fee Waiver Description <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select
                className="form-select"
                name="fw_id"
                value={headerData.fw_id}
                disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Fee Waiver Description--</option>
                {ddlWaivers.map(fd => (
                  <option key={fd.fw_id} value={fd.fw_id}>{fd.fw_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>
               Academic Year <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select className={`form-select ${errors.year1 ? "is-invalid" : ""}`}
                name="year1" value={headerData.year1}
                onChange={handleHeaderChange} disabled={!isEditable} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

        </Row>
        }

        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>
      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                {/* <th style={{ width: '4%', textAlign: 'center' }}>#</th> */}
                <th style={{ width: '15%', textAlign: 'left' }}>Section</th>
                <th style={{ width: '10%', textAlign: 'left' }}>GR No</th>
                <th style={{ width: '27%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Std/Div</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Existing Waiver</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Remarks</th>
                <th style={{ width: '6%', textAlign: 'left' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  {/* <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td> */}
                  <td>
                    <select className="form-select" disabled={!isEditable}
                      name="section_id" value={row.section_id} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">-- Select Section --</option>
                      {ddlSection.map(sec => (
                        <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="gr_no" value={row.gr_no} 
                      onChange={(e) => handleChildChange(index, e)} onBlur={(e) => handleGRNoBlur(index, e)} />
                  </td>
                  <td> {row.stud_name}</td>
                  <td>{row.std_div}</td>
                  <td> {row.existing_fw}</td>

                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="text" className="form-control" name="remarks" value={row.remarks} 
                      onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}


        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary" onClick={addRow}  disabled={!isEditable}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }}> +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default FeeWaiverAllocation;
